<template>
  <perfect-scrollbar
    class="enum-filter"
    :class="{ 'show-more': showMore }"
    :options="{ suppressScrollX: true }"
  >
    <filters-boolean-filter
      v-for="item in list"
      :key="item.id"
      :settings="{ name: item.name, id: 1 }"
      :value="!!statuses[item.id] && statuses[item.id].checked"
      :disabled="!!statuses[item.id] && statuses[item.id].disabled"
      :active="'active' in item ? !!item.active : true"
      emit-position
      label-class="body-m-regular"
      @change="onChange(item.id)"
      @position="onPositionChange"
    />
    <div v-if="isShowMoreButton && !showMore" class="show-more-button">
      <ui-ui-link font-weight="400" @click="onShowMore">
        Показать все
      </ui-ui-link>
    </div>
  </perfect-scrollbar>
</template>

<script lang="ts">
import type { EnumFilter, EnumAllowed } from '~/interfaces/api';

interface CheckboxStatuses {
  [key: number]: {
    checked: boolean;
    disabled: boolean;
  };
}

export default defineComponent({
  name: 'EnumFilterListings',
  props: {
    settings: {
      type: Object as () => EnumFilter,
      required: true,
    },
    disabled: {
      type: Array as () => number[],
      default: () => [] as number[],
    },
    value: {
      type: Array as () => number[],
      required: true,
    },
  },
  emits: ['onChange', 'position', 'show'],
  setup(props, { emit }) {
    const showMore = ref<boolean>(false);
    const list = computed((): EnumAllowed[] => {
      const values = props.settings.allowed_values || [];
      return showMore.value ? values : values.slice(0, 10);
    });
    const isShowMoreButton = computed(
      () =>
        props.settings.allowed_values &&
        props.settings?.allowed_values?.length > 10
    );

    function onChange(id: number): void {
      const index: number = props.value.indexOf(id);
      let newVal: number[] = [];
      if (index > -1) {
        newVal = [
          ...props.value.slice(0, index),
          ...props.value.slice(index + 1),
        ];
      } else {
        newVal = [...props.value, id];
      }

      const queryVal = newVal.length > 0 ? newVal.join(',') : undefined;
      emit('onChange', {
        id: props.settings.id ? props.settings.id.toString() : 0,
        val: newVal,
        queryVal,
      });
    }

    function onPositionChange(val: { right: number; top: number }): void {
      emit('position', val);
    }

    function onShowMore(): void {
      showMore.value = true;
      nextTick(() => emit('show'));
    }

    const statuses = computed(() => {
      const newStatuses: CheckboxStatuses = {};
      props.value?.forEach(
        (el) => (newStatuses[el] = { checked: true, disabled: false })
      );
      if (props.disabled) {
        props.disabled.forEach(
          (el) =>
            (newStatuses[el] = { checked: !!newStatuses[el], disabled: true })
        );
      }
      return newStatuses;
    });

    return {
      onChange,
      statuses,
      showMore,
      onShowMore,
      onPositionChange,
      list,
      isShowMoreButton,
    };
  },
});
</script>

<style scoped lang="scss" src="./enum-filter-listings.scss" />
